module.exports = __webpack_public_path__ + "img/icon-task-white.0d92f58d.svg";